import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../../components/sales/layout/layout";
import {toast} from "react-toastify";

const B2CPendingPaymentRelease = ({
                        match,
                         caseListRequest,
                         caseListResponse = [],
                         carBrandRequest,
                         caseStatusUpdateResponse = [],
                         caseStatusUpdateRequest
                    }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [id, setId] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await caseListRequest(0, 1, 'PENDING_PAYMENTS', 'B2C')
            await carBrandRequest()
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Unique ID',
        'Business Name',
        'Customer Fist Name',
        'Vehicle No',
        'Bank Name',
        'Net disbursal amount',
        'status',
        'Created At',
        'Created By',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await caseListRequest(0, val.selected + 1, 'PENDING_PAYMENTS', 'B2C');
        setIsLoading(false);
    };

    useEffect(() => {

        if (caseListResponse && caseListResponse?.data  &&
            caseListResponse?.data?.resultSets && caseListResponse?.data?.resultSets.length > 0) {
            const tableData = ['id','unique_id', 'dealer_name', 'customer_name', 'vehicle_registration_number', 'bank_name', 'loan_required_amount', 'status','created_at' ,'created_user_name'];
            const data = caseListResponse?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'unique_id' ? {[key]: element['id']} : {[key]: element[key]}
                    )),
                    {
                        Action: [
                            { name: 'View Details', link: `${baseUrl}/ucd/case/payment-raise-view`},
                        ]
                    }
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(caseListResponse?.data?.total / caseListResponse?.data?.per_page));
        }
    }, [caseListResponse])

    useEffect(() => {
        if (parseInt(caseStatusUpdateResponse?.status) === 200) {
            toast.success(caseStatusUpdateResponse?.message);
            setTimeout(()  => {
                window.location.reload();
            }, 1000)
        } else if (
            caseStatusUpdateResponse?.status !== 200
        ) {
            toast.error(caseStatusUpdateResponse?.message);
        }
    }, [caseStatusUpdateResponse]);

    return (
        <>
            <Layout
                title={"Pending Payment Release"}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={caseListResponse?.data?.resultSets}
                    srNo={caseListResponse?.data?.from}
                    // setChangeCarLoanStatusModalOpen={setChangeCarLoanStatusModalOpen}
                    carLoanId={setId}
                />
            </Layout>
        </>
    )
}

export default B2CPendingPaymentRelease

